import { Paper, SxProps, Toolbar } from '@mui/material';
import React, { ReactNode } from 'react';

export interface BottomPanelProps {
  children: ReactNode;
  sx: SxProps;
}

const BottomPanel = ({ children, sx }: BottomPanelProps) => (
  <>
    <Toolbar sx={sx} />
    <Paper
      sx={theme => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        p: 1.75,
        borderRadius: 0,
        backgroundColor: theme.palette.surfaces.panel,
        paddingLeft: { sm: 6, md: 9 },
        paddingRight: { sm: 6, md: 9 },
        zIndex: 1,
      })}
      elevation={4}
    >
      {children}
    </Paper>
  </>
);

export default BottomPanel;
